<template>
    <div class="OlpaSystemQuizView">
        <div class="top-part-wrapper">
            <div class="progress-bar-wrapper">
                <div class="progress-bar" :style="{ width: percentageProgress + '%' }" />
            </div>
            <div class="exit-button-wrapper" @click="$router.go(-1)">{{ $t('systems.exit') }}</div>
        </div>

        <LifeskillSelectionQuiz
            v-if="currentView === 'lifeskill selection quiz'"
            :number="currentStepItem.number"
            :random-step-items="shuffledRandomStepItems"
            @userAnsweredCorrectly="handleUserCorrectQuizAnswer"
        />

        <DragAndDropMemo
            v-else
            :number="currentStepItem.number"
            :step-items="shuffledRandomStepItems"
            @userFinishedMemo="handleUserMemoSuccess"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LifeskillSelectionQuiz from './LifeskillSelectionQuiz';
import DragAndDropMemo from './DragAndDropMemo';

export default {
    components: {
        LifeskillSelectionQuiz,
        DragAndDropMemo
    },

    data() {
        return {
            currentView: 'lifeskill selection quiz',
            currentLifeskillIndex: 0,
            doneTasksCount: 0
        };
    },

    computed: {
        ...mapGetters({
            getSystemById: 'moduleCourse/getSystemById',
            currentLocale: 'moduleApp/locale'
        }),

        system() {
            return this.getSystemById(this.$route.params.systemId);
        },

        journey() {
            return this.system.journeys.find(
                journey => journey.name === this.routeStringToName(this.$route.params.journeyName)
            );
        },

        step() {
            return this.journey.steps.find(step => step.name === this.routeStringToName(this.$route.params.stepName));
        },

        stepItems() {
            return this.step.items[this.currentLocale];
        },

        currentStepItem() {
            return { ...this.stepItems[this.currentLifeskillIndex], isCurrentStepItem: true };
        },

        threeRandomStepItems() {
            const randomIndexes = [];

            while (randomIndexes.length < 3) {
                const randomIndex = Math.round(Math.random() * (this.stepItems.length - 1));

                if (!randomIndexes.includes(randomIndex) && randomIndex !== this.currentLifeskillIndex) {
                    randomIndexes.push(randomIndex);
                }
            }

            return randomIndexes.map(i => this.stepItems[i]);
        },

        shuffledRandomStepItems() {
            const randomStepItems = [...this.threeRandomStepItems, this.currentStepItem];

            return this.shuffleItemsInArray(randomStepItems);
        },

        percentageProgress() {
            return Math.ceil((this.doneTasksCount / (this.stepItems.length * 2)) * 100);
        }
    },

    methods: {
        routeStringToName(string) {
            const firstLetterUppercase = string.charAt(0).toUpperCase();

            return firstLetterUppercase + string.slice(1).split('-').join(' ');
        },

        handleUserCorrectQuizAnswer() {
            this.doneTasksCount++;
            this.setCurrentView('drag and drop items');
        },

        handleUserMemoSuccess() {
            const isQuizFinished = this.percentageProgress === 100;

            if (isQuizFinished) {
                return;
            }

            this.doneTasksCount++;
            this.currentLifeskillIndex++;

            this.setCurrentView('lifeskill selection quiz');
        },

        setCurrentView(view) {
            this.currentView = view;
        },

        shuffleItemsInArray(array) {
            return array.sort(() => 0.5 - Math.random());
        }
    }
};
</script>

<style lang="scss" scoped>
.OlpaSystemQuizView {
    width: 375px;
    height: 809px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px;

    .progress-bar-wrapper {
        height: 10px;

        .progress-bar {
            transition: 0.5s;
            background: white;
            height: 100%;
            width: 0;
        }
    }

    .exit-button-wrapper {
        text-align: right;
        margin-top: 10px;
        color: hsla(0, 0%, 100%, 0.5);
        cursor: pointer;
    }
}
</style>
